const Style = {

  input: 'relative mb-4 last:mb-0',
  base: `relative cursor-pointer w-full overflow-hidden border border-solid border-border 
    after:absolute after:top-1/2 after:mt-1 after:right-4 after:w-3 after:h-3 after:opacity-30 
    after:pointer-events-none after:-translate-y-1/2 after:bg-contain rounded-2xl 
    after:bg-[url('components/form/select/icons/ico-dropdown.svg')]`,
    
  /* Stays bg-transparent, unlike components/form/select: the error/warning
     states here draw their border with a ::before overlay that an opaque select
     would paint over. The global `option` rule in css/input.css already makes
     the dropdown rows readable in dark mode, which is the part that mattered. */
  select: 'relative w-[120%] appearance-none outline-none bg-transparent border-transparent cursor-pointer p-3',
  success: 'border-success mb-0',
  error: 'text-error',

  errorWrapper: `border-0 before:absolute before:left-0 before:right-0 before:top-0 before:bottom-4 
    before:rounded-2xl before:border before:border-solid before:border-error after:-mt-3`,

  warning: 'text-warning',
  warningWrapper: `border-0 before:absolute before:left-0 before:right-0 before:top-0 before:bottom-0
    before:rounded-2xl before:border before:border-solid before:border-warning`,

  message: 'mb-0',

}

export default Style;